// frontend/src/pages/Profile/ProfileInfo.jsx
import React, { useState } from 'react';
import { useProfile } from '../contexts/ProfileContext';
import AlertMessage from '../components/ui/AlertMessage';
import './profile-info.scss'

const ProfileInfo = ({ profile, onUpdate, onChangePassword }) => {
    const { updateProfile, loading } = useProfile();
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        nome_utente: profile?.nome_utente || '',
        cognome_utente: profile?.cognome_utente || '',
        telefono_utente: profile?.telefono_utente || '',
        data_nascita: profile?.data_nascita?.split('T')[0] || '',
        codfiscale_utente: profile?.codfiscale_utente || '',
        iscrizione_newsletter: profile?.iscrizione_newsletter || false
    });
    const [message, setMessage] = useState(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await updateProfile(formData);
        
        if (result.success) {
            setMessage({ type: 'success', text: 'Profilo aggiornato con successo!' });
            setIsEditing(false);
            onUpdate();
            setTimeout(() => setMessage(null), 3000);
        } else {
            setMessage({ type: 'error', text: result.error });
        }
    };

    if (!isEditing) {
        return (
            <div className="profile-info-view">
                <div className="section-header">
                    <h2>Informazioni Personali</h2>
                    <button 
                        className="btn-edit"
                        onClick={() => setIsEditing(true)}
                    >
                        ✏️ Modifica
                    </button>
                </div>

                {message && <AlertMessage type={message.type} message={message.text} />}

                <div className="info-grid">
                    <div className="info-item">
                        <label>Nome</label>
                        <p>{profile?.nome_utente || '-'}</p>
                    </div>
                    <div className="info-item">
                        <label>Cognome</label>
                        <p>{profile?.cognome_utente || '-'}</p>
                    </div>
                    <div className="info-item">
                        <label>Email</label>
                        <p>{profile?.email_utente}</p>
                        <span className="verified-badge">
                            {profile?.email_verificata ? '✅ Verificata' : '⚠️ Non verificata'}
                        </span>
                    </div>
                    <div className="info-item">
                        <label>Telefono</label>
                        <p>{profile?.telefono_utente || '-'}</p>
                    </div>
                    <div className="info-item">
                        <label>Data di nascita</label>
                        <p>{profile?.data_nascita ? new Date(profile.data_nascita).toLocaleDateString('it-IT') : '-'}</p>
                    </div>
                    <div className="info-item">
                        <label>Codice Fiscale</label>
                        <p>{profile?.codfiscale_utente || '-'}</p>
                    </div>
                    <div className="info-item">
                        <label>Newsletter</label>
                        <p>{profile?.iscrizione_newsletter ? '✅ Iscritto' : '❌ Non iscritto'}</p>
                    </div>
                </div>

                <div className="security-section">
                    <button 
                        className="btn-change-password"
                        onClick={onChangePassword}
                    >
                        🔒 Cambia Password
                    </button>
                </div>
            </div>
        );
    }

    return (
        <form className="profile-info-form" onSubmit={handleSubmit}>
            <div className="section-header">
                <h2>Modifica Informazioni</h2>
                <button 
                    type="button"
                    className="btn-cancel"
                    onClick={() => setIsEditing(false)}
                >
                    Annulla
                </button>
            </div>

            {message && <AlertMessage type={message.type} message={message.text} />}

            <div className="form-grid">
                <div className="form-group">
                    <label>Nome *</label>
                    <input
                        type="text"
                        name="nome_utente"
                        value={formData.nome_utente}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Cognome *</label>
                    <input
                        type="text"
                        name="cognome_utente"
                        value={formData.cognome_utente}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Telefono</label>
                    <input
                        type="tel"
                        name="telefono_utente"
                        value={formData.telefono_utente}
                        onChange={handleChange}
                        placeholder="+39 123 456 7890"
                    />
                </div>

                <div className="form-group">
                    <label>Data di nascita</label>
                    <input
                        type="date"
                        name="data_nascita"
                        value={formData.data_nascita}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group full-width">
                    <label>Codice Fiscale</label>
                    <input
                        type="text"
                        name="codfiscale_utente"
                        value={formData.codfiscale_utente}
                        onChange={handleChange}
                        maxLength="16"
                        placeholder="RSSMRA85M10B205X"
                    />
                </div>

                <div className="form-group checkbox">
                    <label>
                        <input
                            type="checkbox"
                            name="iscrizione_newsletter"
                            checked={formData.iscrizione_newsletter}
                            onChange={handleChange}
                        />
                        Iscriviti alla newsletter per ricevere offerte esclusive
                    </label>
                </div>
            </div>

            <div className="form-actions">
                <button type="submit" className="btn-save" disabled={loading}>
                    {loading ? 'Salvataggio...' : '💾 Salva Modifiche'}
                </button>
            </div>
        </form>
    );
};

export default ProfileInfo;
